module.exports = __webpack_public_path__ + "img/Speech_Bubble_noStroke.56c037f3.svg";